import React from 'react'

const options = [
  {
    name: 'cushion',
    img: './menu/cushion.png',
  },
  {
    name: 'wood',
    img: './menu/wood.png',
  },
]

export const OptionsMenu = ({ activeOption, setActiveOption }) => {
  return (
    <div className="options">
      {options.map(({ name, img }, idx) => (
        <div className={`option ${activeOption === name ? '--is-active' : ''}`} data-option={name} onClick={() => setActiveOption(name)} key={name}>
          <img src={img} alt="" />
        </div>
      ))}
    </div>
  )
}
